import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

const PEXELS_API_KEY = process.env.REACT_APP_PEXELS_KEY;

const PLACE_DESCRIPTIONS = {
  'Visit the Gateway Arch': 'Iconic 630-ft stainless steel arch symbolizing westward expansion, with tram rides to the top.',
  'Walk across Eads Bridge': 'Historic 1874 bridge spanning the Mississippi — the first steel truss bridge ever built.',
  'Explore Forest Park': 'One of the largest urban parks in the US, home to museums, trails, and the 1904 World\'s Fair legacy.',
  'Visit the St. Louis Zoo': 'World-class free zoo with over 500 species, located in the heart of Forest Park.',
  'See a Cardinals game at Busch Stadium': 'Catch the St. Louis Cardinals in action at their iconic downtown ballpark.',
  'See a Blues game at Enterprise Center': 'Watch the Stanley Cup champion St. Louis Blues play in the heart of downtown.',
  'Visit the City Museum': 'A wildly creative playground built from architectural salvage — unlike anything else on earth.',
  'Eat at Imos Pizza': 'The home of St. Louis-style pizza on Provel cheese — a local institution since 1964.',
  'Try a St. Paul Sandwich': 'A uniquely STL creation: egg foo young patty on white bread with mayo and pickles.',
  'Visit the Missouri Botanical Garden': '79 acres of stunning gardens, including the famous Climatron greenhouse.',
  'Explore the Cherokee Street Antique District': 'Eclectic stretch of antique shops, murals, and Latin culture in south St. Louis.',
  'Visit the Saint Louis Art Museum': 'World-renowned free art museum atop Art Hill with collections spanning 5,000 years.',
  'Watch a sunset from Art Hill': 'The best free view in St. Louis — golden hour over the reflecting pool and the Arch skyline.',
  'Visit the Missouri History Museum': 'Free museum chronicling St. Louis history from the Louisiana Purchase to the present.',
  'Explore the Soulard Farmers Market': 'One of the oldest farmers markets in the US, open year-round in the heart of Soulard.',
  'Eat at Pappys Smokehouse': 'Award-winning BBQ joint famous for slow-smoked ribs and long lunch lines.',
  'Visit the Anheuser-Busch Brewery': 'Tour the historic home of Budweiser and see the legendary Clydesdales up close.',
  'Walk the Delmar Loop': 'Vibrant stretch of shops, restaurants, and live music anchored by the St. Louis Walk of Fame.',
  'Visit the St. Louis Science Center': 'Free hands-on science museum with an OMNIMAX theater and outdoor dinosaur exhibits.',
  'See a show at Fox Theatre': 'Opulent 1929 movie palace — one of the grandest theaters in America.',
  'Visit the Cahokia Mounds': 'Pre-Columbian Native American city and UNESCO World Heritage Site just across the river.',
  'Eat at Toasted Bagelry': 'Local favorite for fresh-baked bagels and creative sandwiches in St. Louis.',
  'Explore Lafayette Square': 'STL\'s oldest park neighborhood, surrounded by beautiful Victorian mansions.',
  'Visit the Cathedral Basilica of St. Louis': 'Stunning cathedral with one of the largest mosaic collections in the world.',
  'Try Ted Drewes Frozen Custard': 'A St. Louis summer tradition since 1929 — the concrete shakes are legendary.',
  'See a show at The Muny': 'The nation\'s oldest and largest outdoor musical theater, free seats available every night.',
  'Visit the St. Louis Blues Hall of Fame': 'Celebrate the history of one of hockey\'s most beloved franchises.',
  'Explore Tower Grove Park': 'Victorian-era park with ornate pavilions, walking paths, and summer concerts.',
  'Visit the Citygarden Sculpture Park': 'Free outdoor sculpture garden in the heart of downtown with interactive water features.',
  'Eat at Gioias Deli': 'Legendary south city Italian deli famous for their hot salami sandwich.',
  'See a live show at Blueberry Hill': 'Chuck Berry\'s legendary haunt on the Loop — great burgers and live music nightly.',
  'Visit the National Blues Museum': 'Immersive museum celebrating the history and legacy of American blues music.',
  'Explore the Laumeier Sculpture Park': 'Free outdoor sculpture park spanning 105 acres in south St. Louis County.',
  'Eat at The Shaved Duck': 'Beloved south city spot known for smoked meats and craft beer in a cozy setting.',
  'Visit Grants Farm': 'Free Anheuser-Busch family attraction with exotic animals, Clydesdales, and tram rides.',
  'See a concert at Chaifetz Arena': 'Premier mid-size concert venue on the Saint Louis University campus.',
  'Walk through Soulard neighborhood': 'STL\'s oldest neighborhood, packed with bars, live music, and Mardi Gras energy.',
  'Visit the Old Courthouse': 'Historic courthouse where the Dred Scott case was tried, now a free national landmark.',
  'Eat at Rigazzis on The Hill': 'Classic Italian-American dining on The Hill since 1947, famous for the fishbowl drinks.',
  'Try toasted ravioli for the first time': 'St. Louis\'s most famous culinary invention — breaded and deep-fried pasta perfection.',
  'Visit the Saint Louis University campus': 'Beautiful Jesuit university campus with stunning Gothic architecture in midtown STL.',
  'See a show at Peabody Opera House': 'Restored 1925 theater hosting major national touring acts and local performances.',
  'Explore the Botanical Garden Climatron': 'Geodesic dome greenhouse housing a lush tropical rainforest environment year-round.',
  'Visit the Magic House': 'Award-winning children\'s museum with interactive exhibits for all ages.',
  'Eat at Broadway Oyster Bar': 'Legendary Cajun seafood spot in Laclede\'s Landing with live music every night.',
  'See a show at The Pageant': 'One of the best mid-size music venues in the country, right on the Delmar Loop.',
  'Visit the Soldiers Memorial': 'Solemn downtown memorial honoring St. Louis veterans with free museum and exhibits.',
  'Explore Creve Coeur Lake Park': 'Beautiful 2,000-acre park with a scenic lake, trails, and water sports west of the city.',
  'See a St. Louis City SC soccer game': 'Cheer on STL\'s brand new MLS team at the stunning downtown CITYPARK stadium.',
  'Visit the Saint Louis Aquarium': 'Downtown aquarium at Union Station featuring sharks, otters, and stingray touch pools.',
  'Eat at Lombardos Trattoria': 'Upscale Italian dining in the heart of the downtown theater district.',
  'See a concert at Hollywood Casino Amphitheatre': 'Massive outdoor amphitheater hosting the biggest national touring acts all summer.',
  'Visit the Ulysses S. Grant National Historic Site': 'Tour White Haven, the historic home of President Grant, just west of the city.',
  'Explore the Belleville Farmers Market': 'Popular weekly market just across the river in charming downtown Belleville, IL.',
  'See a Billikens game at Chaifetz Arena': 'Root for SLU\'s nationally competitive Billikens basketball team on campus.',
  'Visit the Scott Joplin House': 'National Historic Landmark preserving the home of the King of Ragtime music.',
  'Eat at Franco on Olive': 'Sophisticated French-American bistro in the heart of downtown St. Louis.',
  'Explore the Maplewood neighborhood': 'Hip south county neighborhood packed with indie restaurants, bars, and boutiques.',
  'See a show at Stray Dog Theatre': 'Intimate community theater known for bold, thought-provoking productions.',
  'Visit the St. Louis Walk of Fame': 'Bronze stars and plaques honoring famous St. Louisans embedded in the Delmar Loop sidewalk.',
  'Watch Fourth of July fireworks at the Arch': 'The greatest fireworks show in the Midwest, lighting up the Mississippi riverfront.',
};

const scheduleNotification = (title, date, time) => {
  const scheduledTime = new Date(`${date}T${time}`).getTime();
  const now = Date.now();
  const delay = scheduledTime - now;
  if (delay <= 0) return;
  if ('Notification' in window && Notification.permission === 'granted') {
    setTimeout(() => {
      new Notification(`Reminder: ${title}`, {
        body: `Scheduled for ${new Date(`${date}T${time}`).toLocaleString([], {
          month: 'numeric', day: 'numeric', year: '2-digit',
          hour: '2-digit', minute: '2-digit'
        })}`,
        icon: '/logo192.png'
      });
    }, delay);
  }
};

const requestNotificationPermission = async (title, date, time) => {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'granted') {
    scheduleNotification(title, date, time);
  } else if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      scheduleNotification(title, date, time);
    }
  }
};

const PlaceCard = ({ place, onClose, onToggle, onSchedule, onDeleteSchedule, onDeletePlace, isGuest }) => {
  const { theme } = useTheme();
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [scheduled, setScheduled] = useState(false);
  const [notifStatus, setNotifStatus] = useState('');
  const [editingSchedule, setEditingSchedule] = useState(false);
  const [photoUrl, setPhotoUrl] = useState(place.photoUrl || null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const isUserAdded = !!place.userAdded;
  const autoDescription = PLACE_DESCRIPTIONS[place.title] || null;
  const displayDescription = place.description || autoDescription;

  useEffect(() => {
    if (!place.photoUrl && PEXELS_API_KEY) {
      const query = encodeURIComponent(place.title + ' St Louis Missouri');
      fetch(`https://api.pexels.com/v1/search?query=${query}&per_page=1&orientation=landscape`, {
        headers: { Authorization: PEXELS_API_KEY }
      })
        .then(res => res.json())
        .then(data => {
          if (data.photos && data.photos.length > 0) {
            setPhotoUrl(data.photos[0].src.large);
          }
        })
        .catch(() => setPhotoUrl(null));
    }
  }, [place.title, place.photoUrl]);

  const handleSchedule = async () => {
    if (selectedDate && selectedTime) {
      onSchedule(place.id, `${selectedDate}T${selectedTime}`);
      setScheduled(true);
      setEditingSchedule(false);
      if (!('Notification' in window)) {
        setNotifStatus('Notifications not supported on this browser.');
        return;
      }
      if (Notification.permission === 'denied') {
        setNotifStatus('Notifications blocked. Enable in browser settings.');
        return;
      }
      await requestNotificationPermission(place.title, selectedDate, selectedTime);
      if (Notification.permission === 'granted') {
        setNotifStatus('Reminder set!');
      } else {
        setNotifStatus('Reminder saved but notifications were not enabled.');
      }
    }
  };

  const handleDeleteSchedule = () => {
    if (onDeleteSchedule) {
      onDeleteSchedule(place.id);
      setScheduled(false);
      setSelectedDate('');
      setSelectedTime('');
      setNotifStatus('');
      setEditingSchedule(false);
    }
  };

  const handleDirections = () => {
    const directionHint = place.directions ? ` ${place.directions}` : '';
    const query = encodeURIComponent(place.title + directionHint + ' St. Louis MO');
    window.open(`https://www.google.com/maps/search/${query}`, '_blank');
  };

  const handleAddToCalendar = () => {
    if (!selectedDate || !selectedTime) return;
    const startDateTime = new Date(`${selectedDate}T${selectedTime}`);
    const endDateTime = new Date(startDateTime.getTime() + 60 * 60 * 1000);
    const formatGoogleDate = (date) =>
      date.toISOString().replace(/-|:|\.\d{3}/g, '').slice(0, 15) + 'Z';
    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: place.title,
      dates: `${formatGoogleDate(startDateTime)}/${formatGoogleDate(endDateTime)}`,
      details: place.description || `Visit ${place.title} in St. Louis, MO`,
      location: place.address || `${place.title}, St. Louis, MO`,
    });
    window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, '_blank');
  };

  const handleDeletePlace = async () => {
    if (isUserAdded) {
      onDeletePlace && onDeletePlace(place.id);
      onClose();
    } else {
      // Hide default place via backend
      try {
        const token = JSON.parse(sessionStorage.getItem('user'))?.token;
        await fetch(`https://fifty-two-in-the-lou-production.up.railway.app/api/checklist/${place.id}/hide-default`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` }
        });
        onDeletePlace && onDeletePlace(place.id);
        onClose();
      } catch (e) {
        console.error('Failed to hide place', e);
      }
    }
  };

  const existingDate = place.scheduledDate
    ? new Date(place.scheduledDate).toISOString().slice(0, 10)
    : '';
  const existingTime = place.scheduledDate
    ? new Date(place.scheduledDate).toTimeString().slice(0, 5)
    : '';

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 999, padding: '20px'
    }}>
      <div style={{
        backgroundColor: theme.cardBackground,
        borderRadius: '16px',
        width: '100%',
        maxWidth: '480px',
        maxHeight: '85vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <div style={{
          backgroundColor: theme.headerBackground,
          padding: '16px 20px',
          borderRadius: '16px 16px 0 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ color: theme.headerText, margin: 0, fontSize: '1.1rem', flex: 1 }}>
            {place.title}
          </h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: theme.headerText,
            fontSize: '1.5rem', cursor: 'pointer', padding: '0 0 0 10px'
          }}>✕</button>
        </div>

        <img
          src={photoUrl || '/stl-flag-fallback.png'}
          alt={place.title}
          onError={(e) => { e.target.src = '/stl-flag-fallback.png'; }}
          style={{ width: '100%', height: '200px', objectFit: 'cover' }}
        />

        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <span style={{
              backgroundColor: theme.buttonPrimary,
              color: theme.buttonText,
              padding: '4px 10px',
              borderRadius: '20px',
              fontSize: '0.78rem',
              fontWeight: '700'
            }}>
              {place.category}
            </span>
          </div>

          {displayDescription && (
            <p style={{ color: theme.subText, margin: 0, fontSize: '0.9rem', lineHeight: '1.5' }}>
              {displayDescription}
            </p>
          )}

          {!isGuest && place.scheduledDate && !editingSchedule && (
            <div style={{
              backgroundColor: theme.background,
              borderRadius: '8px',
              padding: '12px',
              border: `1px solid ${theme.border}`
            }}>
              <p style={{ color: '#22c55e', fontWeight: '700', margin: '0 0 8px 0', fontSize: '0.9rem' }}>
                Scheduled: {new Date(place.scheduledDate).toLocaleString()}
              </p>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => {
                    setSelectedDate(existingDate);
                    setSelectedTime(existingTime);
                    setEditingSchedule(true);
                  }}
                  style={{
                    flex: 1, padding: '8px', borderRadius: '8px', border: 'none',
                    backgroundColor: theme.buttonPrimary, color: theme.buttonText,
                    fontWeight: '700', cursor: 'pointer', fontSize: '0.8rem'
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={handleDeleteSchedule}
                  style={{
                    flex: 1, padding: '8px', borderRadius: '8px', border: 'none',
                    backgroundColor: '#ef4444', color: 'white',
                    fontWeight: '700', cursor: 'pointer', fontSize: '0.8rem'
                  }}
                >
                  Delete Schedule
                </button>
              </div>
            </div>
          )}

          {!isGuest && (!place.scheduledDate || editingSchedule) && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <p style={{ color: theme.text, fontWeight: '700', margin: 0 }}>
                {editingSchedule ? 'Update Schedule' : 'Schedule a Visit'}
              </p>
              <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  style={{
                    padding: '10px', borderRadius: '8px',
                    border: `2px solid ${theme.border}`,
                    backgroundColor: theme.background,
                    color: theme.text, fontSize: '0.9rem',
                    colorScheme: theme.background === '#f5f5f5' ? 'light' : 'dark',
                    width: '100%', boxSizing: 'border-box'
                  }}
                  />
                  <input
                  type="time"
                  value={selectedTime}
                  onChange={(e) => setSelectedTime(e.target.value)}
                  style={{
                    padding: '10px', borderRadius: '8px',
                    border: `2px solid ${theme.border}`,
                    backgroundColor: theme.background,
                    color: theme.text, fontSize: '1.1rem',
                    colorScheme: theme.background === '#f5f5f5' ? 'light' : 'dark',
                    WebkitAppearance: 'none',
                    cursor: 'pointer',
                    width: '100%', boxSizing: 'border-box'
                  }}
                  />
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={handleSchedule}
                  disabled={!selectedDate || !selectedTime}
                  style={{
                    flex: 1, padding: '12px', borderRadius: '8px', border: 'none',
                    backgroundColor: selectedDate && selectedTime ? '#22c55e' : theme.border,
                    color: selectedDate && selectedTime ? 'white' : theme.subText,
                    fontWeight: '700', cursor: selectedDate && selectedTime ? 'pointer' : 'not-allowed',
                    fontSize: '0.9rem'
                  }}
                >
                  {editingSchedule ? 'Update' : 'Save to Schedule'}
                </button>
                {editingSchedule && (
                  <button
                    onClick={() => setEditingSchedule(false)}
                    style={{
                      padding: '12px', borderRadius: '8px',
                      border: `2px solid ${theme.border}`,
                      backgroundColor: 'transparent', color: theme.text,
                      fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
                    }}
                  >
                    Cancel
                  </button>
                )}
              </div>

              {notifStatus !== '' && (
                <p style={{
                  fontSize: '0.8rem',
                  color: notifStatus.includes('set') ? '#22c55e' : theme.subText,
                  margin: 0, textAlign: 'center'
                }}>
                  {notifStatus}
                </p>
              )}

              {(scheduled || place.scheduledDate) && selectedDate && selectedTime && (
                <button
                  onClick={handleAddToCalendar}
                  style={{
                    padding: '12px', borderRadius: '8px', border: 'none',
                    backgroundColor: '#4285F4', color: 'white',
                    fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
                  }}
                >
                  Add to Google Calendar
                </button>
              )}
            </div>
          )}

          <button
            onClick={handleDirections}
            style={{
              padding: '12px', borderRadius: '8px', border: 'none',
              backgroundColor: theme.buttonPrimary, color: theme.buttonText,
              fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
            }}
          >
            Get Directions
          </button>

          <button
            onClick={() => { onToggle(place.id); onClose(); }}
            style={{
              padding: '12px', borderRadius: '8px',
              border: `2px solid ${theme.border}`,
              backgroundColor: 'transparent', color: theme.text,
              fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
            }}
          >
            {place.status === 'visited' ? 'Mark as Unvisited' : 'Mark as Visited'}
          </button>

          {!isGuest && (
            <>
              {!showDeleteConfirm ? (
                <button
                  onClick={() => setShowDeleteConfirm(true)}
                  style={{
                    padding: '12px', borderRadius: '8px', border: 'none',
                    backgroundColor: '#ef4444', color: 'white',
                    fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
                  }}
                >
                  {isUserAdded ? 'Delete This Place' : 'Remove from List'}
                </button>
              ) : (
                <div style={{
                  backgroundColor: theme.background,
                  border: `1px solid #ef4444`,
                  borderRadius: '8px',
                  padding: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px'
                }}>
                  <p style={{ color: theme.text, fontWeight: '700', margin: 0, fontSize: '0.9rem', textAlign: 'center' }}>
                    {isUserAdded
                      ? 'Delete this place permanently?'
                      : 'Remove from your list? It will return on Reset.'}
                  </p>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => setShowDeleteConfirm(false)}
                      style={{
                        flex: 1, padding: '10px', borderRadius: '8px',
                        border: `2px solid ${theme.border}`,
                        backgroundColor: 'transparent', color: theme.text,
                        fontWeight: '700', cursor: 'pointer', fontSize: '0.85rem'
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleDeletePlace}
                      style={{
                        flex: 1, padding: '10px', borderRadius: '8px', border: 'none',
                        backgroundColor: '#ef4444', color: 'white',
                        fontWeight: '700', cursor: 'pointer', fontSize: '0.85rem'
                      }}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaceCard;